import { gql } from '@apollo/client';

export const QUOTE_REBATE_FRAGMENT = gql`
  fragment QuoteRebateFields on QuoteRebateResponse {
    amount
    description
    equipmentId
  }
`;
